import React from 'react';
import { useOptionValue } from '~/hooks/components/use-option-value';
import AddToCartButton from './AddToCartButton';
import QuickshopSizeButton from './SizeButton';
import { Button, Text } from 'theme-ui';
import StockRequestForm from './StockRequestForm';
import useProductAvailability from '~/hooks/components/use-product-availability';
import { SharedProps } from '.';

type CurrentTrayStepProps = {
  isLoading: boolean;
  variantStock?: boolean | null;
} & SharedProps;

const CurrentTrayStep = ({
  product,
  selectedVariant,
  isLoading,
  selectedColor,
  handleSizeClick,
  selectedSize,
  currentStep,
  variantStock,
  setCurrentStep,
  setSelectedSize,
}: CurrentTrayStepProps) => {
  const { productWithStock, isFetching } = useProductAvailability(product);
  const [allSizes, allSizesWithStock] = useOptionValue(productWithStock ?? product, 'size');
  if ((currentStep === 'add-to-cart' || currentStep === 'out-of-stock') && selectedSize && selectedVariant?.sku) {
    const isAvailable =
      (allSizesWithStock !== null &&
        !isFetching &&
        allSizesWithStock[selectedSize.presentation!].inStock[selectedColor?.presentation!]) ||
      (!isLoading && Boolean(variantStock));

    return (
      <>
        <QuickshopSizeButton size={selectedSize} selectedSize={selectedSize} isAvailable={isAvailable} />
        <Button
          variant="bare"
          sx={{ fontSize: '1.4rem', fontWeight: 400, lineHeight: 1.15, textDecoration: 'underline' }}
          onClick={() => {
            setCurrentStep('variant');
            setSelectedSize(null);
          }}
        >
          Change
        </Button>
        <AddToCartButton sku={selectedVariant.sku} setCurrentStep={setCurrentStep} currentStep={currentStep} />
      </>
    );
  }
  if (currentStep === 'stock-request' && selectedVariant) {
    return (
      <>
        <StockRequestForm product={product} selectedVariant={selectedVariant} setCurrentStep={setCurrentStep} />
      </>
    );
  }

  if (currentStep === 'added-to-cart') {
    return (
      <>
        <Text variant="text.paragraphSmall">
          Your {product.name} in {selectedColor?.presentation} and size {selectedSize?.presentation} was added to your
          cart.
        </Text>
      </>
    );
  }

  return (
    <>
      {allSizes.map((size) => {
        // if no selected color, show that it's available
        const isAvailable =
          selectedColor && !isFetching
            ? allSizesWithStock?.[size.presentation!].inStock[selectedColor?.presentation!] ?? true
            : true;

        return (
          <QuickshopSizeButton
            key={size.id}
            handleSizeClick={handleSizeClick}
            size={size}
            selectedSize={selectedSize}
            isAvailable={isAvailable}
          />
        );
      })}
    </>
  );
};
export default CurrentTrayStep;
